import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import PageinateGroup from '../pageinate/pageinate_group.js';

var _ref = React.createElement(
	'label',
	{ htmlFor: 'tag_filter' },
	'Filter By:'
);

var _ref2 = React.createElement(
	'option',
	{ value: 'all' },
	'All'
);

var _ref3 = React.createElement('div', null);

var Collection = function (_Component) {
	_inherits(Collection, _Component);

	function Collection() {
		_classCallCheck(this, Collection);

		var _this = _possibleConstructorReturn(this, (Collection.__proto__ || Object.getPrototypeOf(Collection)).call(this));

		_this.state = {
			filter_tag: 'all'
		};
		_this.onChangeFilter = _this.onChangeFilter.bind(_this);

		return _this;
	}

	_createClass(Collection, [{
		key: 'onChangeFilter',
		value: function onChangeFilter(e) {
			var filter_tag = e.currentTarget.value;
			this.setState({ filter_tag: filter_tag });
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    collection = _props.collection,
			    display_num = _props.display_num,
			    current_page = _props.current_page;
			var filter_tag = this.state.filter_tag;

			console.log("COLLECTION", collection);
			var products = collection.products.edges;

			var collection_tags = [];
			products.forEach(function (product) {
				collection_tags = [].concat(_toConsumableArray(collection_tags), _toConsumableArray(product.node.tags));
			});

			collection_tags = collection_tags.filter(function (tag, index) {
				return collection_tags.indexOf(tag) === index;
			});

			if (products.length > 0) {
				return React.createElement(
					'div',
					{ className: 'Section-featured-collections wrapper-small' },
					React.createElement(
						'header',
						{ role: 'banner', className: 'collection-title' },
						React.createElement(
							'h2',
							null,
							collection.title
						),
						React.createElement(
							'div',
							{ className: 'collection-filters' },
							_ref,
							React.createElement(
								'select',
								{ name: 'filter', id: 'tag_filter', onChange: function onChange(e) {
										_this2.onChangeFilter(e);
									} },
								_ref2,
								collection_tags.map(function (tag) {
									return React.createElement(
										'option',
										{ value: tag },
										tag
									);
								})
							)
						)
					),
					React.createElement(PageinateGroup, {
						products: products,
						display_num: display_num,
						current_page: current_page,
						filter_tag: filter_tag
					})
				);
			} else {
				return _ref3;
			}
		}
	}]);

	return Collection;
}(Component);

export default Collection;